(function () {
  var STORAGE_KEY = 'th-videos-ready';
  var MAX_VISIBLE_MS = 450;

  function shouldRun() {
    try {
      if (sessionStorage.getItem(STORAGE_KEY)) return false;
    } catch (error) {
      return false;
    }

    return !window.matchMedia('(max-width: 699px)').matches;
  }

  function hideLoader(loader) {
    if (!loader || loader.dataset.done === 'true') return;
    loader.dataset.done = 'true';

    loader.classList.add('is-hiding');
    document.documentElement.classList.remove('th-page-loading');

    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      /* ignore */
    }

    setTimeout(function () {
      loader.setAttribute('aria-hidden', 'true');
    }, 500);
  }

  function init() {
    var loader = document.getElementById('th-page-loader');
    if (!loader) return;

    if (!shouldRun()) {
      hideLoader(loader);
      return;
    }

    document.documentElement.classList.add('th-page-loading');
    loader.setAttribute('aria-hidden', 'false');

    setTimeout(function () {
      hideLoader(loader);
    }, MAX_VISIBLE_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
